// 工具：类型按钮的渲染与交互

export const renderTypeButtons = ({ showAgentType, typeList, selectedInputType }) => {
    if (!showAgentType) return '';
    return (typeList || []).map((item) => {
        const active = selectedInputType === item.type ? 'active' : '';
        return `<span class="feedback-input-type-btn ${active}" data-type="${item.type}">${item.name}</span>`;
    }).join('');
};

export const bindTypeButtons = ({ container, onSelect, selectedInputType }) => {
    if (!container) return;
    const typeBtns = container.querySelectorAll('.feedback-input-type-btn');
    if (!typeBtns) return;

    typeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const type = e.target.dataset.type;
            if (typeof onSelect === 'function') {
                onSelect(type);
            }
            updateActiveButtons(container, type);
        });
    });

    updateActiveButtons(container, selectedInputType);
};

export const updateTypeButtonsDOM = ({ container, showAgentType, typeList, selectedInputType, onSelect }) => {
    if (!container) return;
    const typeContainer = container.querySelector('.feedback-input-type');
    if (!typeContainer) return;

    typeContainer.innerHTML = renderTypeButtons({ showAgentType, typeList, selectedInputType });
    bindTypeButtons({ container, onSelect, selectedInputType });
};

export const updateActiveButtons = (container, selectedInputType) => {
    const typeBtns = container?.querySelectorAll('.feedback-input-type-btn');
    if (!typeBtns) return;
    typeBtns.forEach(btn => {
        if (btn.dataset.type === selectedInputType) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });
};

